/*
 *  I15MASVOLAPHUMLReducer.ts
 *
 *  Created by Sébastien Hecart on 2022-05-29 21:26:16 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

import { I15MASVOLAPHUML_State } from '@batical/types/src'

const I15MASVOLAPHUML: I15MASVOLAPHUML_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_massVolApp: 400.0,
  in_humiditeRf: 25.0,
  in_humiditeSouhaite: 25.0,
  res_massVolBois: 560.0,
  mode: 'none',
  calcul_code: 'I15MASVOLAPHUML'
}

export default I15MASVOLAPHUML
